module.exports = __webpack_public_path__ + "img/gn.36a3e9a3.svg";